import React from 'react'
import styles from './styles.module.css'

const ImageScreen = ({src}) => {
    return (
        <img className={styles.img} src={src} alt="Imagem" />
    )
}

export default ImageScreen